// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28fc6b8c","239":"4e41511e","732":"cf917035"}[chunkId] + ".chunk.js";
};